import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Covid19Batch, RunLane } from '../agptesting-newview/model/covid19Batch';
import { AuthUtil } from '../common-services/auth-util';
import * as jwt_decode from 'jwt-decode';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { ArticDeliveryPlanningService } from './artic-delivery-planning.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { saveAs as saveByFileSaver } from "file-saver";

@Component({
  selector: 'app-artic-delivery-planning',
  templateUrl: './artic-delivery-planning.component.html',
  styleUrls: ['./artic-delivery-planning.component.css']
})
export class ArticDeliveryPlanningComponent implements OnInit {

  
  @ViewChild('topDiv',{static : false}) elementView: ElementRef;
  selectedLabId: string;
  batches: Covid19Batch[];
  errorHandler: ErrorHandler = new ErrorHandler;
  loading: boolean = false;
  totalRecords: number;
  blocked: boolean = false;
  scrollableCols: any[];
  divHeight: number;
  scrollHeight: string;
  readonly blueberryAPGNGSKonstanzLabUsersBatchActionUsers ='BlueberryAPGNGSKonstanzLabUsersBatchActionUsers';
  readonly blueberryUKDTCPopGenBatchActionUsers ='BlueberryUKDTCPopGenBatchActionUsers';
  validRole: boolean;
  batchIDToStartDelivery = [];
  puid: string;
  listOfFile:any;
  selectedLab: any;
  constructor(private _messagesService: MessagesService, private articDeliveryPlanningService: ArticDeliveryPlanningService, 
    private datepipe: DatePipe, private router: Router) {

  }

  ngOnInit() {
    this.selectedLab = JSON.parse(localStorage.getItem('lab')).lab
    this.selectedLabId =this.selectedLab._id;
    this.puid = localStorage.getItem('PUID');
    this.getDataForDeliveryPlanning();
    this.getFilesFromAzure();
    this.scrollableCols = [
      { 'header': 'Batch ID', 'field': 'batchID' },
      { 'header': 'External ID', 'field': 'externalIdentification' },
      { 'header': 'Sender Short Name', 'field': 'sender' },
      { 'header': 'No. of Samples', 'field': 'sampleListSizeWithoutControls' },
      { 'header': 'Delivery Target Date', 'field': 'deliveryTargetDateTime' },
      { 'header': 'Library ID', 'field': 'libraryId' },
      { 'header': 'Tag Plate', 'field': 'tagPlateId' },
      { 'header': 'RunID Lane', 'field': 'runAndLaneIdInfo' },
      { 'header': 'Sequencing Run', 'field': 'transferSequencingDateTime' },
      { 'header': 'Primary Analysis', 'field': 'startPrimaryAnalysisDateTime' },
      { 'header': 'Secondary Analysis', 'field': 'startSecondaryAnalysisDateTime' },
      { 'header': 'Data Review', 'field': 'startDataReviewDateTime' },
      { 'header': 'Delivery', 'field': 'startDeliveryDateTime' }
    ]
    this.validRole = this.decideIfBBRoleExists();
    this.onResize();
  }

  getDataForDeliveryPlanning() {
    this.blocked = true;
    let today = new Date();
    let fromDate = this.addBusinessDays(today, -2);
    let strDate = this.datepipe.transform(fromDate, 'E MMM dd yyyy')
    this.articDeliveryPlanningService.getBatchesForLab(this.selectedLabId, strDate).subscribe(
      result => {
        if (result.data  && result.data.batches) {
          this.batches = result.data.batches;
          this.batchIDToStartDelivery = result.data.batches.filter((batch) => !batch['startDeliveryDateTime'] 
            && !batch['deliveryCompletionDateTime'] && batch['readyForDeliveryDateTime']).map(batch => batch.batchID);
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      }

    )
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    if (this.elementView != undefined) {
      this.scrollHeight = document.documentElement.clientHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight - 200+ 'px';
      this.divHeight = window.innerHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight-200;
    }
  }

  getTextCellValue(field: string, batch: any){
    if( batch[field] && (field == 'deliveryTargetDateTime' || field == 'transferSequencingDateTime' || field == 'startPrimaryAnalysisDateTime'
          || field == 'startSecondaryAnalysisDateTime' || field == 'startDataReviewDateTime' || field == 'startDeliveryDateTime')){
            
          field= this.getFieldNameForDeliveyStatus(field,batch);
      return this.datepipe.transform(batch[field].$date, this.selectedLab.dateTimeFormat);
    }
    if(batch[field] && (field == 'runAndLaneIdInfo') && batch[field].length > 0){
      let lastRun: RunLane = batch.runAndLaneIdInfo[batch.runAndLaneIdInfo.length - 1];
      batch['transferSequencingDateTime'] = lastRun.runSequencingDateTime;
      return lastRun.runId+" - "+lastRun.laneId;
    }
    return batch[field];
  }

  getFieldNameForDeliveyStatus(field: string, batch: any){
    if(field == 'transferSequencingDateTime' && batch['completedSequencingDateTime']){
      field = 'completedSequencingDateTime';
    }
    else if(field == 'startPrimaryAnalysisDateTime' && batch['completePrimaryAnalysisDateTime']){
      field = 'completePrimaryAnalysisDateTime';
    }
    else if(field == 'startSecondaryAnalysisDateTime' && batch['completeSecondaryAnalysisDateTime']){
      field = 'completeSecondaryAnalysisDateTime';
    }
    else if(field == 'startDataReviewDateTime' && batch['readyForDeliveryDateTime']){
      field = 'readyForDeliveryDateTime';
    }else if(field == 'startDeliveryDateTime' && batch['deliveryCompletionDateTime']){
      field = 'deliveryCompletionDateTime';
    }
    return field;
  }
  getCellColor(field: string, batch: Covid19Batch){
    if( batch[field] && (field == 'transferSequencingDateTime' || field == 'startPrimaryAnalysisDateTime'
          || field == 'startSecondaryAnalysisDateTime' || field == 'startDataReviewDateTime' || field == 'startDeliveryDateTime')){
           
          if( (field == 'transferSequencingDateTime' && batch['completedSequencingDateTime']) 
              || (field == 'startPrimaryAnalysisDateTime' && batch['completePrimaryAnalysisDateTime'])
              || (field == 'startSecondaryAnalysisDateTime' && batch['completeSecondaryAnalysisDateTime'])
              || (field == 'startDeliveryDateTime' && batch['deliveryCompletionDateTime'])){
            return "completed";
          }
		      else if(field == 'startDataReviewDateTime'){
            return this.handleDataReviewColor(batch);
          }
          else{
            return "started";
          }
     }
    return "normal";
  }

  handleDataReviewColor(batch: Covid19Batch){
    if(batch.statusOfTheBatch == "REDO"){
      return "redCell";
    }
    else if(batch['readyForDeliveryDateTime']){
      return "completed";
    }
    else{
      return "started";
    }
  }

  decideIfBBRoleExists() {
    let roles = this.getRolesFromAccessToken();
    if(roles.length > 0) {
      return roles.includes(this.blueberryAPGNGSKonstanzLabUsersBatchActionUsers) || roles.includes(this.blueberryUKDTCPopGenBatchActionUsers)
    }
    return false;
  }

  getRolesFromAccessToken() {
    let authUtil = new AuthUtil()
    let accessToken = authUtil.getAccessToken()
    if(accessToken)
    {
      let access_token = jwt_decode(accessToken);
      return access_token.roles;
    }
    return [];
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  //adding working days to given date
  addBusinessDays(d:Date, n:number) {
    d = new Date(d.getTime());
    var day = d.getDay();
    d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
    return d;
  }

  createCofigFile(){
    if(this.batchIDToStartDelivery && this.batchIDToStartDelivery.length > 0){
      this.blocked = true;
      let today = new Date();
      let strDate = this.datepipe.transform(today, 'yyyyMMdd-HHmmss');
      this.articDeliveryPlanningService.updateBatchesForLab(this.selectedLabId,strDate, this.batchIDToStartDelivery, this.puid).subscribe(
        result => {
          if (result.data) {
            this.batchIDToStartDelivery =[];
            this.getDataForDeliveryPlanning();
            this.getFilesFromAzure();
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Created successfully',
              detail: 'Delivery Config text files have been Created',
            });
          }
          this.blocked = false;
        },
        error => {
          this.handleError(error);
        }
  
      )
    }
  }

  getFilesFromAzure(){
    this.blocked = true;
    this.articDeliveryPlanningService.getFilesFromAzure().subscribe(result=>{
      if (result.data) {
        this.listOfFile = result.data;
      }
      this.blocked = false;
    },
    error => {
      this.handleError(error);
    });
  }

  downloadFile(fileName: string){
    this.blocked = true;
    this.articDeliveryPlanningService.downloadFile(fileName).subscribe(result=>{
      var blob = new Blob([result.body], { type: 'txt' });
          if(blob.size!=0){
            let blobTxt: Blob = new Blob([blob], { type: 'application/octet-stream' });
            saveByFileSaver(blobTxt, fileName);
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Download is successful',
              detail: 'Delivery Config text file has been downloaded',
            });
          }else{
            this._messagesService.addErrorMessage({
              severity: 'success', summary: 'No Content',
              detail: 'Empty File.',
            });
          }
          this.blocked = false;
    },
    error => {
      this.handleError(error);
    });
  }
}
